import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import '../../sheet/bottom-sheet/index.esm.js';
import '../../sheet/popover-sheet/index.esm.js';
import '../../sheet/side-sheet/index.esm.js';
import '../../sheet/centered-sheet/index.esm.js';
import '../../sheet/full-sheet/index.esm.js';
import { EGDSSheet } from '../../sheet/sheet/index.esm.js';
import '../../sheet/sheet-content/index.esm.js';
import '../../sheet/sheet-close-button/index.esm.js';
import { EGDSSheetTransition } from '../../sheet/sheet-transition/index.esm.js';
import '../../sheet/sheet-footer/index.esm.js';
import '../../sheet/types/index.esm.js';
import styles from '../../styles/uitk-egds-dialog.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { EGDSContextProvider } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
var EGDSDialogAnimationType;
(function (EGDSDialogAnimationType) {
  EGDSDialogAnimationType["NONE"] = "none";
  EGDSDialogAnimationType["FADE"] = "fade";
  EGDSDialogAnimationType["SLIDEDOWN"] = "slidedown";
  EGDSDialogAnimationType["SLIDELEFT"] = "slideleft";
  EGDSDialogAnimationType["SLIDERIGHT"] = "slideright";
  EGDSDialogAnimationType["SLIDEUP"] = "slideup";
})(EGDSDialogAnimationType || (EGDSDialogAnimationType = {}));
class EGDSDialog extends React.Component {
  static displayName = 'EGDSDialog';
  static defaultProps = {
    animation: EGDSDialogAnimationType.NONE,
    autoFocus: true,
    heightAuto: false,
    returnFocusOnClose: false,
    strictFullscreen: false
  };
  iphoneSafariUARegex = /iphone.*safari|safari.*iphone/gi;
  constructor(props) {
    super(props);
    this.setDialogHeightForSafariOnIphone = this.setDialogHeightForSafariOnIphone.bind(this);
    this.setHeight = this.setHeight.bind(this);
    this.detectIphoneSafariPortrait = this.detectIphoneSafariPortrait.bind(this);
  }
  componentDidMount() {
    this.detectIphoneSafariPortrait() && this.setDialogHeightForSafariOnIphone();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.setHeight);
  }
  setHeight() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
  }
  setDialogHeightForSafariOnIphone() {
    this.setHeight();
    window.addEventListener('resize', this.setHeight);
  }
  detectIphoneSafariPortrait() {
    return typeof window !== 'undefined' && typeof navigator !== 'undefined' && !!navigator.userAgent.match(this.iphoneSafariUARegex) && typeof window.matchMedia === 'function' && window.matchMedia('(orientation: portrait)').matches;
  }
  render() {
    const {
      ariaLabel,
      autoFocus,
      children,
      className,
      closeCallback,
      dialogShow,
      heightAuto,
      openCallback,
      returnFocusOnClose,
      strictFullscreen,
      triggerRef,
      sheetType = 'centered'
    } = this.props;
    const defaultRef = React.createRef(); // Adding default Ref in case there's none provided
    if (!children) {
      return null;
    }
    const wrapperClassNames = getClassNameList('uitk-dialog', 'uitk-dialog-sheet', className, {
      'uitk-dialog-fullscreen-strict': strictFullscreen,
      'uitk-dialog-height-auto': heightAuto
    });
    return jsx(EGDSContextProvider, {
      config: {
        context: 'uitk-dialog-context'
      },
      children: jsx(EGDSSheetTransition, {
        isVisible: dialogShow,
        openCallback: openCallback,
        closeCallback: closeCallback,
        children: jsx(EGDSSheet, {
          autoFocus: autoFocus,
          returnFocusOnClose: returnFocusOnClose,
          isVisible: dialogShow,
          type: sheetType,
          triggerRef: triggerRef || defaultRef,
          className: wrapperClassNames,
          ariaLabel: ariaLabel,
          centeredSheetSize: "small",
          children: children
        })
      })
    });
  }
}
export { EGDSDialog, EGDSDialogAnimationType };